<div class="seancesupload container page">
  <div class="row">
    <div class="col-4">
      <div class="seancesupload__toupload">
        <div class="seancesupload__toupload__label">Séances à livrer</div>
        @if (this.seances.length > 0) {
<app-seances-list
         
          [seances]="this.seances"
          (selectSeanceEvent)="this.onSelectSeance($event)"
          [selectedSeance]="this.selectedSeance?.id"
        />
}
      </div>
    </div>
    <div class="col-8">
      @if (!this.selectedSeance) {
<div class="seancesupload__selected">
        Sélectionnez une séance à livrer
      </div>
}
      @if (this.selectedSeance) {
<div class="seancesupload__selected">
        Séance {{ this.selectedSeance.langue }} du
        {{ this.selectedSeance.date_creation | date : "dd/MM/yyyy" }}
      </div>
}
      @if (this.selectedSeance && !this.isSeanceLoading) {
<div>
        <div class="d-flex align-items-center justify-content-between mb-3">
          @if (this.standbyPvs > 0) {
<div class="text-danger">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{ this.standbyPvs }} texte{{ this.standbyPvs > 1 ? 's' : '' }} en standby
          </div>
}
          <button
            class="btn btn-outline-primary"
            [ngClass]="{
              'btn-outline-primary': this.isPartialDeliveryCollapsed,
              'btn-primary': !this.isPartialDeliveryCollapsed
            }"
            (click)="
              this.isPartialDeliveryCollapsed = !this.isPartialDeliveryCollapsed
            "
          >
            Je souhaite faire une livraison partielle
          </button>
        </div>
        <div
          class="mb-3"
          #collapse="ngbCollapse"
          [(ngbCollapse)]="this.isPartialDeliveryCollapsed"
        >
          <div class="card">
            <div class="cardbody">
              <table class="table">
                <thead>
                  <tr>
                    <td>
                      <div class="form-check form-switch">
                        <input
                          #allPVsSwitch
                          class="form-check-input"
                          type="checkbox"
                          name=""
                          id=""
                          role="switch"
                          [checked]="
                            this.seancePVs.length ===
                            this.seancePartialPVs.length
                          "
                          (click)="
                            this.addOrRemoveAllPvs(allPVsSwitch.checked)
                          "
                        />
                      </div>
                    </td>
                    <td>Référence</td>
                    <td>Phase vocale</td>
                    <td>Guide</td>
                  </tr>
                </thead>
                <tbody>
                  @for (pv of this.seancePVs; track pv) {
<tr>
                    <td>
                      <div class="form-check form-switch">
                        <input
                          #pvSwitch
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          (click)="
                            this.addOrRemovePvs(
                              pvSwitch.checked,
                              pv.ZMS_PVCODE1,
                              pv
                            )
                          "
                          [checked]="this.pvChecked(pv.ZMS_PVCODE1)"
                        />
                      </div>
                    </td>
                    <td>{{ pv.ZMS_PVCODE1 }}</td>
                    <td>
                      {{
                        this.ccLibelleService.getCcLibelle(
                          pv.ZMS_PHASEVOCALE,
                          this.phasesVocales
                        )
                      }}
                    </td>
                    <td [ngbTooltip]="pv.ZMS_GUIDE" container="body">
                      {{ pv.ZMS_GUIDE | truncate : 20 }}
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="seancesupload__filedrop">
          <label class="form-label" for="seance-upload-file"
            >Fichier de la séance (Mp3, Wav, Zip, 7-zip - Max. 500Mo)</label
          >
          <input
            class="form-control"
            type="file"
            name="seance-upload-file"
            id="seance-upload-file"
            accept="audio/mpeg, audio/wav, application/zip, application/x-7z-compressed"
            (change)="this.getSeanceFile($event)"
          />
        </div>

        <div class="text-end mt-3">
          @if (!this.isSeanceLoading) {
<button
           
            class="btn btn-primary"
            (click)="this.openUploadDialog()"
            [disabled]="this.isSeanceLoading || this.isPosting || !this.seanceFile"
          >
            Livrer
          </button>
}
        </div>
      </div>
}
      @if (this.isSeanceLoading) {
<div>
        <app-loader />
      </div>
}
    </div>
  </div>

  <app-dialog
    #postDialog
    title="Livrer des enregistrements"
    [visibility]="this.uploadDialiogVisible"
    (closeDialogEvent)="this.uploadDialiogVisible = $event"
  >
    @if (this.selectedSeance) {
<div>
      <app-post-states
        [isPosting]="this.isPosting"
        [isPostingOver]="this.isPostingOver"
        [postError]="this.postError"
        [definedProgress]="true"
        [progress]="this.uploadCurrentSizeUploaded"
        readyMessage="Vous allez livrer la séance {{
          this.selectedSeance.id
        }} du {{ this.selectedSeance.date_creation | date : 'dd/MM/yyyy' }}"
        postingMessage="La séance est en cours de livraison"
        completeMessage="La séance a été livrée avec succès"
      />
    </div>
}
    <div dialog-footer>
      @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="postDialog.closeDialog()"
        >
          Annuler
        </button>
        <button class="btn btn-success" (click)="this.generatePV()">
          Valider
        </button>
      </div>
}
      @if (this.isPostingOver) {
<div>
        <button
          class="btn btn-success me-2"
          (click)="
            postDialog.closeDialog()
          "
        >
          Fermer
        </button>
      </div>
}
      @if (this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="postDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
    </div>
  </app-dialog>
</div>
